import axios from 'axios';
import { client } from '@/services/api/axios.ts';
import { useQuery } from '@tanstack/react-query';
import { TSession } from '@/features/auth/schemas/auth.schema.ts';

async function getSession(): Promise<TSession | undefined | never> {
  try {
    const { data } = await client.get(`/auth/session`);

    return data.body;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(`${error?.response?.data?.message}`);
    }

    if (error instanceof Error) {
      throw new Error(`${error.message}}`);
    }
  }
}

export const useSessionQuery = ({ enabled }: { enabled: boolean }) => {
  return useQuery({
    queryKey: ['auth', 'session'],
    queryFn: getSession,
    retry: 1,
    staleTime: 1000 * 60 * 15, // 15 minutes
    enabled,
  });
};
